import { Button, Input } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { PAGE_LENGTH, subscriptionPlans } from "../config";
import { useAlert } from "../context/AlertProvider";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import useUpgradeAlert from "./hooks/useUpgradeAlert";

const QuickSelection = ({
  selectedRange,
  onChangeSelectedRange,
  onClickQuickSelection,
  onClearQuickSelection,
  isClearVisible,
  totalRecords,
}) => {
  const { showAlert } = useAlert();
  const showUpgradeAlert = useUpgradeAlert();
  const { isAuthenticated, subscription } = useContext(AuthContext);
  const handleSelectData = () => {
    const totalPages = Math.ceil(totalRecords / PAGE_LENGTH);
    const start = parseInt(selectedRange.start);
    const end = parseInt(selectedRange?.end);
    if (start && end) {
      const calcRecords =
        (parseInt(selectedRange.end) - parseInt(selectedRange.start)) * 10;

      let errorMessage = "";

      const validationCase =
        start > end
          ? "START_GREATER_THAN_END"
          : end > totalPages
            ? "END_EXCEEDS_TOTAL"
            : calcRecords > 500
              ? "MAX_PAGES_EXCEEDED"
              : null;

      switch (validationCase) {
        case "START_GREATER_THAN_END":
          errorMessage = "Start page number must be less than end page number.";
          break;
        case "END_EXCEEDS_TOTAL":
          errorMessage = "End page number must be less than total page.";
          break;
        case "MAX_PAGES_EXCEEDED":
          errorMessage = "Please select a maximum of 50 pages at a time.";
          break;
        default:
          errorMessage = null;
      }

      if (errorMessage) {
        showAlert("error", errorMessage);
      } else {
        onClickQuickSelection();
      }
    } else {
      if (start === 0) {
        showAlert("error", "Start page number must be greater than zero.");
      } else {
        showAlert(
          "error",
          "Please select start page number and end page number."
        );
      }
    }
  };

  return (
    <div className="static-top">
      <div className="m-mt quickselection">
        <div className="tw-flex tw-items-center">
          <span className="tw-text-sm tw-font-medium tw-mr-2">
            Quick Selection
          </span>
          <div className="tw-text-sm sm:tw-inline-block tw-mr-1">
            <Input
              name="start"
              type="number"
              value={selectedRange?.start}
              className="!tw-h-[38px] tw-w-[44px] !tw-rounded-lg !tw-border-slate-200"
              maxLength={4}
              min={1}
              onChange={onChangeSelectedRange}
            />
          </div>
          <span className="tw-text-sm mr-1">to</span>
          <div className="tw-text-sm sm:tw-inline-block tw-mr-1">
            <Input
              name="end"
              type="number"
              value={selectedRange?.end}
              maxLength={4}
              min={1}
              className="!tw-h-[38px] tw-w-[44px] !tw-rounded-lg !tw-border-slate-200"
              onChange={onChangeSelectedRange}
            />
          </div>
          <Button
            type="primary"
            className="tw-text-xs tw-mr-1 !tw-h-[38px] !tw-w-[38px] !tw-rounded-lg tw-flex tw-justify-center tw-items-center quick-btn !tw-bg-theme"
            onClick={() => {
              if (
                isAuthenticated &&
                [subscriptionPlans?.trail].includes(
                  subscription?.subscriptionPackage?.name
                )
              ) {
                showUpgradeAlert();
              } else {
                handleSelectData();
              }
            }}
          >
            <i className="fas tw-text-xs fa-arrow-right"></i>
          </Button>
          {isClearVisible ? (
            <Button
              type="primary"
              className="tw-text-xs tw-mr-1 !tw-h-[38px] !tw-w-[38px] !tw-rounded-lg tw-flex tw-justify-center tw-items-center quick-btn !tw-bg-theme"
              onClick={onClearQuickSelection}
            >
              <CloseOutlined />
            </Button>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

export default QuickSelection;
